import { Link } from "react-router-dom";
import { ESSAY_PRIZE_NAV_ITEMS } from "../../lib/essayPrizeNav";
import { marketingUrl } from "../../lib/marketingUrls";
import logoWhite from "../../assets/oq-logo-1-white.svg";
import linkedInIcon from "../../assets/homepage/social-icon-linkedin.svg";
import "./Footer.scss";

export default function Footer() {
  return (
    <footer>
      <div className="footer-cols-wrapper">
        <div className="col-1">
          <div className="col-inner-wrapper">
            <a href={marketingUrl("/")}>
              <img src={logoWhite} alt="OphthalmologyQ" className="logo-footer" />
            </a>
            <p>
              <strong>FRCOphth Part 1 &amp; Part 2</strong> question banks covering <strong>every module and every
              area</strong>—exam-style questions, timed mock exams, and UK-aligned explanations. Plus <strong>MSRA</strong>,{" "}
              <strong>Duke Elder</strong>, interview resources, and <strong>coaching from leading UK ophthalmologists</strong>.{" "}
              <strong>Co-built by ophthalmologists, for ophthalmologists.</strong>
            </p>
            <div className="social-icons-wrapper">
              <Link to={"https://linkedin.com"} target="blank">
                <img src={linkedInIcon} alt="Link to MasterQ LinkedIn page" />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-2">
          <div className="col-inner-wrapper">
            <h4>Resources</h4>
            <ul>
              <li>
                <a href={marketingUrl("/about")}>About</a>
              </li>
              <li>
                <a href={marketingUrl("/about#about-oq")}>About OQ</a>
              </li>
              <li>
                <a href={marketingUrl("/about#why-us")}>Purpose-built</a>
              </li>
              <li>
                <a href={marketingUrl("/about#our-vision")}>Our vision</a>
              </li>
              <li>
                <a href={marketingUrl("/#pricing")}>Pricing</a>
              </li>
              <li>
                <a href={marketingUrl("/#newsletter")}>Newsletter</a>
              </li>
              <li>
                <a href={marketingUrl("/national-essay-prizes")}>National Essay Prizes</a>
              </li>
              {ESSAY_PRIZE_NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <a href={marketingUrl(item.path)}>{item.label}</a>
                </li>
              ))}
              <li>
                <Link to={"/sign-up"}>Sign Up</Link>
              </li>
              <li>
                <a href="mailto:ophthalmologyq@gmail.com">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-3">
          <div className="col-inner-wrapper">
            <h4>Contact Us</h4>
            <ul>
              <li>ophthalmologyq@gmail.com</li>
              <li>
                MasterQ Ltd,<br/>The Exchange,<br/>3 Centenary Square,<br/>Birmingham,<br/>B1 2DR,<br/>United Kingdom.
              </li>

              <li>
              <a onClick={() => {
                  window.scrollTo(0, 0)
                }} id="backToTop">Scroll to top ^</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom-part">
        <p>Copyright © {new Date().getFullYear()} OphthalmologyQ. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
